import { createAsyncThunk } from '@reduxjs/toolkit';
import { SecureClient, debug } from '../../../../utils';

export const FetchCityStateApi = createAsyncThunk(
  'FetchCityStateApi',
  async (payload, { dispatch }) => {
    dispatch({ type: 'FetchCityStateApi/pending', payload: {} });

    const { customerId, Authorization, pinCode } = payload;
    debug('LOOK', `Fetch city state payload:`, payload);
    SecureClient({
      isEncrypted: false,
      customerId,
      otherPayloadDetailsPresent: true,
      route: `customeronboarding/fetch-city-state?pincode=${pinCode}`,
      headers: { Authorization },
      method: 'GET',
      successFn: (res) => {
        debug('WATCH', `Response fetch city state: `, res);
        dispatch({
          type: 'FetchCityStateApi/fulfilled',
          payload: res,
        });
      },
      errorFn: (err) => {
        debug('ERROR', `Error: `, err);
        dispatch({ type: 'FetchCityStateApi/rejected', payload: err });
      },
    });
  }
);

export const FetchCityStateApi_extrareducer = {
  [FetchCityStateApi.pending]: (state, action) => {
    state.fetchCityStateApiState.isLoading = true;
  },
  [FetchCityStateApi.fulfilled]: (state, action) => {
    state.fetchCityStateApiState.isLoading = false;
    state.fetchCityStateApiState.isSuccess = true;
    state.fetchCityStateApiState.isError = false;
    state.fetchCityStateApiState.response = action.payload;
  },
  [FetchCityStateApi.rejected]: (state, action) => {
    state.fetchCityStateApiState.isLoading = false;
    state.fetchCityStateApiState.isSuccess = false;
    state.fetchCityStateApiState.isError = true;
    state.fetchCityStateApiState.response = action.payload;
  },
};
